function getUrlParameter(sParam) {
    let sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
};

function copyToClipboard(text) {
    let input = document.createElement('input');
    input.setAttribute('value', text);
    document.body.appendChild(input);
    input.select();
    let result = document.execCommand('copy');
    document.body.removeChild(input);
    return result;
}

function setLink(track) {
    const $modal = $('#ibaggage-delivery-modal');
    const $copyLink = $('.ibaggage-delivery-copy-link');
    const $copyBtn = $('.ibaggage-delivery-copy-btn');
    const copyLink = `${window.location.protocol}//${window.location.hostname}${window.location.pathname}?tr=${track}`;

    $modal.attr('data-copy-track', track);
    $copyLink.attr('href', copyLink).text(copyLink);
    $copyBtn.attr('data-copy-link', copyLink);
}

function getTrackInfo(track) {
    const $modal = $('#ibaggage-delivery-modal');
    const $response = $modal.find('[data-ibaggage-delivery-response]');
    const $form = $modal.find('[data-ibaggage-delivery-form]');
    const $message = $modal.find('[data-ibaggage-delivery-message]');
    const $loader = $modal.find('[data-ibaggage-delivery-loader]');

    $response.addClass('ibaggage-delivery-hidden');
    $form.addClass('ibaggage-delivery-hidden');
    $message.addClass('ibaggage-delivery-hidden');

    $.ajax({
        type: 'POST',
        dataType: 'text',
        url: '/wp-admin/admin-ajax.php',
        data: {
            action: 'ibaggage-delivery-widget',
            track: track,
        },
        beforeSend: function() {
            $loader.show();
        },
        success: function(data) {
            const response = $.parseJSON(data);

            if (response) {
                if (response.success) {
                    const $attributesList = $modal.find('[data-ibaggage-delivery-attributes]');
                    const $statusList = $modal.find('[data-ibaggage-delivery-status]');
                    let attributesItems = '';
                    let statusItems = '';

                    if (response.data.status) {
                        attributesItems += `<li><span>Статус:</span> <span>${response.data.status}</span></li>`;
                    }
                    if (response.data.batch) {
                        attributesItems += `<li><span>Номер квитанции:</span> <span>${response.data.batch}</span></li>`;
                    }
                    if (response.data.date) {
                        attributesItems += `<li><span>Дата создания:</span> <span>${response.data.date}</span></li>`;
                    }
                    if (response.data.places) {
                        attributesItems += `<li><span>Мест:</span> <span>${response.data.places}</span></li>`;
                    }
                    if (response.data.weight) {
                        attributesItems += `<li><span>Вес:</span> <span>${parseFloat(response.data.weight)} кг</span></li>`;
                    }
                    if (response.data.volume) {
                        attributesItems += `<li><span>Объём:</span> <span>${parseFloat(response.data.volume)} м<sup>3</sup></span></li>`;
                    }
                    if (response.data.paid) {
                        attributesItems += `<li><span>Оплата:</span> <span>${response.data.paid}</span></li>`;
                    }
                    if (response.data.type) {
                        attributesItems += `<li><span>Характер груза:</span> <span>${response.data.type}</span></li>`;
                    }

                    if (response.data.statuses) {
                        $(response.data.statuses).each(function (index, item) {
                            if (this.message) {
                                let statusClasses = '';

                                if (this.dt) {
                                    statusClasses = 'ibaggage-delivery-status-item-ready';

                                    if (response.data.statuses[index + 1] && response.data.statuses[index + 1].dt.length === 0) {
                                        statusClasses = 'ibaggage-delivery-status-item-last';
                                    }
                                }

                                statusItems += `<div class="ibaggage-delivery-status-item ${statusClasses}"><strong>${this.message}</strong><span>${this.dt}</span></div>`;
                            }
                        });
                    }

                    $attributesList.html(`<ul>${attributesItems}</ul>`);
                    $statusList.html(`<div>${statusItems}</div>`);
                    $response.removeClass('ibaggage-delivery-hidden');
                    $loader.hide();
                } else {
                    if (response.data.message) {
                        $message.html(`<div>${response.data.message}</div>`);
                    }
                    $message.removeClass('ibaggage-delivery-hidden');
                    $form.removeClass('ibaggage-delivery-hidden');
                    $loader.hide();
                }
            }
        }
    });
}

$(document).on('click', '[data-ibaggage-delivery-toggle="modal"]', function (e) {
    e.preventDefault();

    const $modal = $('#ibaggage-delivery-modal');
    const $trackInput = $('#ibaggage-delivery-input');

    $trackInput.removeClass('ibaggage-delivery-input-error');

    if ($trackInput && $trackInput.val()) {
        getTrackInfo($trackInput.val());
        setLink($trackInput.val());

        if ($modal) {
            $modal.addClass('open');
        }

    } else {
        $trackInput.addClass('ibaggage-delivery-input-error');
    }

    $trackInput.val('');

    return false;
});

$(document).on('click', '[data-ibaggage-delivery-toggle="modal-next"]', function (e) {
    e.preventDefault();

    const $modal = $('#ibaggage-delivery-modal');
    const $response = $modal.find('[data-ibaggage-delivery-response]');
    const $form = $modal.find('[data-ibaggage-delivery-form]');
    const $loader = $modal.find('[data-ibaggage-delivery-loader]');
    const $trackInput = $modal.find('[data-ibaggage-delivery-form] input');

    $trackInput.removeClass('ibaggage-delivery-input-error');
    $trackInput.val('');
    $loader.show();

    if ($modal) {
        $modal.addClass('open');
    }

    $response.addClass('ibaggage-delivery-hidden');
    $form.removeClass('ibaggage-delivery-hidden');

    setTimeout(function () {
        if (window.location.href.indexOf('?') > -1) {
            window.location.href = window.location.pathname;
        }
        $loader.hide();
    }, 300);

    return false;
});

$(document).on('click', '[data-ibaggage-delivery-toggle="modal-search"]', function (e) {
    e.preventDefault();

    const $modal = $('#ibaggage-delivery-modal');
    const $trackInput = $modal.find('[data-ibaggage-delivery-form] input');

    $trackInput.removeClass('ibaggage-delivery-input-error');

    if ($trackInput && $trackInput.val()) {
        getTrackInfo($trackInput.val());
        setLink($trackInput.val());

        if ($modal) {
            $modal.addClass('open');
        }

    } else {
        $trackInput.addClass('ibaggage-delivery-input-error');
    }

    $trackInput.val('');

    return false;
});

$(document).on('click', '[data-ibaggage-delivery-dismiss="modal"]', function (e) {
    const $element = $(this);

    $element.closest('#ibaggage-delivery-modal.open').removeClass('open');

    return false;
});

$(document).on('click', '[data-copy-link]', function () {
    const $element = $(this);

    copyToClipboard($element.data('copy-link'));

    return false;
});

$(document).ready(function () {
  if (getUrlParameter('tr')) {
      $('#ibaggage-delivery-input').val(getUrlParameter('tr'));
      $('[data-ibaggage-delivery-toggle="modal"]').click();
  }
});
